const columns = [
  {
    key: "deviceCode",
    zh: "整机编号",
    en: "Device Code",
    width: "14%"
  },
  {
    key: "company",
    zh: "公司名称",
    en: "Company",
    width: "16%"
  },
  {
    key: "model",
    zh: "机型",
    en: 'Model',
    width: "11%"
  },
  {
    key: "avgFrequency",
    zh: "平均频率(Hz)",
    en: "Average Frequency(Hz)",
    width: "19%",
    tooltip: true
  },
  {
    key: "inverterTemperature",
    zh: "上限频率(Hz)",
    en: "Rated Frequency(Hz)",
    width: "17%",
    tooltip: true
  },
  {
    key: "avgCurrent",
    zh: "平均电流(A)",
    en: "Average Current(A)",
    width: "13%",
    tooltip: true
  },
  {
    key: "percentage",
    zh: "高温率",
    en: "Percentage",
    width: "10%"
  }
]

export default columns